import { immerable } from 'immer';

interface IOrganization {
	id: number;
	code: string;
	name: string;
}

const entityDefaults: IOrganization = {
	id: -1,
	code: '',
	name: '',
};

export class UserOrganization implements IOrganization {
	private [immerable] = true;
	public id = entityDefaults.id;
	public code = entityDefaults.code;
	public name = entityDefaults.name;

	public static build(params: Partial<IOrganization> = {}): UserOrganization {
		const inst = new UserOrganization();
		inst.id = params.id ?? entityDefaults.id;
		inst.code = params.code ?? entityDefaults.code;
		inst.name = params.name ?? entityDefaults.name;
		return inst;
	}

	public static DefaultValue(): UserOrganization {
		const instance = new UserOrganization();
		instance.id = 1;
		instance.name = 'Adobis';
		return instance;
	}
}
